import React from 'react';
import { FieldComponentProps } from 'components/anvilFormFillable/fields/types';
import PhoneInput from 'components/common/PhoneInput';
import { phoneMask } from 'components/communiqueByPatientInfo';

export default function Phone({
  field,
  value,
  onChange,
  ...props
}: FieldComponentProps) {
  return (
    <PhoneInput
      {...props}
      id={field?.id ?? ''}
      autoFocus
      value={value?.value as string}
      onChange={(number) => {
        onChange?.({ ...value, value: number?.toString() });
      }}
      mask={phoneMask}
    />
  );
}
